import LABELS from '@/constants/labels'
export default [
  // home
  {
    path: '/',
    component: () => import('@/layouts/main'),
    children: [
      {
        path: '/',
        name: 'home',
        meta: { title: LABELS.homeTitle },
        component: () => import('@/pages/home'),
      },
      {
        path: '/term',
        name: 'term',
        meta: { title: LABELS.TnC },
        component: () => import('@/pages/term'),
      },
      {
        path: '/layout',
        name: 'select-layout',
        meta: { title: LABELS.layoutTitle },
        component: () => import('@/pages/selectLayout'),
      },
      {
        path: '/template',
        name: 'select-template',
        meta: { title: LABELS.templateTitle },
        component: () => import('@/pages/selectTemplate'),
      },
      {
        path: '/preview',
        name: 'preview',
        meta: { title: LABELS.previewTitle },
        component: () => import('@/pages/preview'),
      },
      {
        path: '/background',
        name: 'background',
        meta: { guard: 'module', title: LABELS.backgroundTitle },
        component: () => import('@/pages/background'),
      },
      {
        path: '/text',
        name: 'text',
        meta: { guard: 'module', title: LABELS.textTitle },
        component: () => import('@/pages/addText'),
      },
      {
        path: '/stamp',
        name: 'stamp',
        meta: { guard: 'module', title: LABELS.stampTitle },
        component: () => import('@/pages/stamp'),
      },
      {
        path: '/avatar',
        name: 'select-avatar',
        meta: { guard: 'module', title: LABELS.createAvatarTitle },
        component: () => import('@/pages/showAvatar'),
      },
      {
        path: '/export',
        name: 'export',
        meta: { guard: 'module', title: LABELS.exportTitle },
        component: () => import('@/pages/export'),
      },
      {
        path: '/faq',
        name: 'faq',
        meta: { title: 'FAQ' },
        component: () => import('@/pages/faq'),
      },
    ],
  },

  // pc screen
  // {
  //   path: '/pc-screen',
  //   name: 'pc-screen',
  //   meta: { title: 'PC Screen' },
  //   component: () => import('@/pages/pcScreen'),
  // },
  // 403
  {
    path: '/403',
    name: '403',
    component: () => import('@/pages/errors/403'),
    meta: { title: LABELS.errorPage },
  },

  // 404
  {
    path: '*',
    name: '404',
    component: () => import('@/pages/errors/404'),
    meta: { title: LABELS.errorPage },
  },
]
